import React, { useContext, useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import {
    DirectoryContext,
    GlDrawerState,
} from "@components/settings/Directory/Directory.context";
import { DirectoryGlDrilldownDrawer } from "@components/settings/Directory/DirectoryGlDrilldownDrawer";
import { omitTaskScope } from "./counterpartiesTaskView";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    drawerState: GlDrawerState | null;
    originalFilters?: FiltersTypes;
}

export const CounterpartiesTaskGlDrawer: React.FC<Props> = ({
    isOpen,
    onClose,
    drawerState,
    originalFilters,
}) => {
    const directoryContext = useContext(DirectoryContext);
    const drilldownContext = useMemo(
        () =>
            originalFilters
                ? {
                      ...directoryContext,
                      view: {
                          ...directoryContext.view,
                          filters: {
                              ...directoryContext.view.filters,
                              ...omitTaskScope(originalFilters),
                          },
                      },
                  }
                : directoryContext,
        [directoryContext, originalFilters],
    );

    return (
        <DirectoryContext.Provider value={drilldownContext}>
            <DirectoryGlDrilldownDrawer
                open={isOpen}
                onClose={onClose}
                counterpartyId={drawerState?.counterpartyId ?? null}
                isNoCounterparty={drawerState?.isNoCounterparty ?? false}
                accountCode={drawerState?.accountCode}
            />
        </DirectoryContext.Provider>
    );
};
